var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ivu-cell-item" }, [
    _c("div", { staticClass: "ivu-cell-icon" }, [_vm._t("icon")], 2),
    _vm._v(" "),
    _c("div", { staticClass: "ivu-cell-main" }, [
      _c(
        "div",
        { staticClass: "ivu-cell-title" },
        [
          _vm._t("default", function() {
            return [_vm._v(_vm._s(_vm.title))]
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ivu-cell-label" },
        [
          _vm._t("label", function() {
            return [_vm._v(_vm._s(_vm.label))]
          })
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ivu-cell-footer" }, [
      _c(
        "span",
        { staticClass: "ivu-cell-extra" },
        [
          _vm._t("extra", function() {
            return [_vm._v(_vm._s(_vm.extra))]
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d518f06a", { render: render, staticRenderFns: staticRenderFns })
  }
}